import { Trans } from "@lingui/react/macro";

import ServiceRow, {
  ServiceRowImages,
  ServiceRowTitle,
  ServiceRowContent
} from "components/ServiceRow/ServiceRow";
import ServiceRows from "components/ServiceRow/ServiceRows";
import React from "react";
import { arrayIsNotEmpty } from "src/utils/checks";
import { ShipDiningAreaFragment } from "types/graphql-types";

type Props = {
  diningAreas: ShipDiningAreaFragment[];
};

const ShipDiningAreasRows: React.FC<Props> = ({ diningAreas }) => {
  if (!arrayIsNotEmpty(diningAreas)) return;

  return (
    <ServiceRows
      readMore={diningAreas.length > 2}
      openReadMoreLabel={<Trans>View all dining options</Trans>}
      closeReadMoreLabel={<Trans>View less</Trans>}
    >
      {diningAreas.map((service, index) => {
        return (
          <React.Fragment key={service._key}>
            {service.card && (
              <ServiceRow
                key={service._key}
                variant={index % 2 ? "right" : "left"}
                backgroundColor="white"
              >
                <ServiceRowImages
                  items={[service.card.image]}
                  fallbackAlt={service.card.title?.localized}
                />
                <ServiceRowTitle>
                  {service.card.title?.localized}
                </ServiceRowTitle>
                <ServiceRowContent>
                  {service.card.description?.localized}
                </ServiceRowContent>
              </ServiceRow>
            )}
          </React.Fragment>
        );
      })}
    </ServiceRows>
  );
};

export default ShipDiningAreasRows;
